/* eslint-disable operator-linebreak */
import { FC, useState } from 'react';
import { HospitalSettings } from './HospitalSettings';
import { BlockSchedule } from './BlockSchedule';

export const Settings: FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { name: 'Hospital Settings', content: <HospitalSettings /> },
    { name: 'Prime Time', content: <BlockSchedule /> },
  ];

  return (
    <div className="w-full mx-auto">
      <div className="border-b border-gray-200">
        <nav className="flex space-x-8">
          {tabs.map((tab, index) => (
            <button
              key={tab.name}
              onClick={() => setActiveTab(index)}
              className={`
                py-4 px-1 text-center border-b-2 font-medium text-2xl transition-colors duration-300
                ${
                  activeTab === index
                    ? 'border-blue text-blue font-bold'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-y-indigo-200 font-bold'
                }
              `}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>

      <div className="mt-8">{tabs[activeTab].content}</div>
    </div>
  );
};
